/* eslint-disable no-param-reassign */

/* ============
 * Campaigns Mutations
 * ============
 *
 * The mutations available for the campaigns module.
 */

import * as types from './types';

export default {
  /**
   * Mutation to update the store with the fetched campaigns.
   *
   * @param {Object} state      The current state of the store.
   * @param {Array}  campaigns      The fetched campaigns.
   * @param {Object} pagination The fetched pagination.
   */
  [types.ALL](state, { campaigns, pagination }) {
    state.all = campaigns;
    Object.assign(state.pagination, pagination);
  },

  /**
   * Mutation to update the store when the request to fetch campaigns fails
   *
   * @param {any} state The current state of the store
   */
  [types.NONE](state) {
    state.all = [];
    state.pagination.totalCount = 0;
    state.pagination.totalPages = 1;
    state.pagination.limit = 20;
  },

  /**
   * Mutation to respond to the action when a campaign has been created.
   *
   * @param {Object} state The current state of the store.
   * @param {Object} campaign  The campaign that has been created.
   */
  [types.CREATED](state, campaign) {
    const {
      totalCount,
      limit,
    } = state.pagination;

    state.pagination.totalCount += 1;

    if (totalCount % limit === 0) {
      state.pagination.totalPages += 1;
    }

    if (limit > state.all.length) {
      state.all.push(campaign);
    }
  },

  /**
   * Mutation to respond to the action when a campaign has been updated.
   *
   * @param {Object} state The current state of the store.
   * @param {Object} campaign  The campaign that has been updated.
   */
  [types.UPDATED](state, campaign) {
    state.all = state.all.map((item) => {
      if (item.id === campaign.id) {
        return campaign;
      }

      return item;
    });
  },

  /**
   * Mutation to respond to the action when a campaign has been destroyed.
   *
   * @param {Object} state The current state of the store.
   */
  /* [types.DESTROYED](state) {
        const {
      currentPage,
      totalCount,
      limit,
      totalPages,
    } = state.pagination;

    let page = currentPage;

    if (totalPages === currentPage && currentPage !== 1 && totalCount % limit === 1) {
      page -= 1;
    }
  }, */

  [types.UPDATE_LIMIT](state, limit) {
    state.pagination.limit = limit;
  },

  [types.UPDATE_CURRENT_PAGE](state, currentPageNumber) {
    state.pagination.currentPage = currentPageNumber;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/campaigns/mutations.js